import { Component, OnInit } from '@angular/core';

import { User, ErrCode } from '../../shared/models';
import { LoggerService } from '../../core/logger.service';
import { MultiAdminService } from '../../core/multiadmin.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProvisionService } from '../../account/services/provision.service';
import { ValidateTokenOutput } from '../../shared/models/multiadmin.model';

@Component({
    selector: 'sync-user-invite-consent',
    templateUrl: './legacy-user-invite-consent.component.html',
    providers: [MultiAdminService]
})
export class LegacyUserInviteConsentComponent implements OnInit {

    public confirmcode: string;
    public user: User;
    public errcode: ErrCode;
    public spinner = true;
    public isInviteChecked = false;
    public isInviteValid = false;
    public invitee = '';
    public declineSuccess = false;
    public acceptSuccess = false;
    public isPaid = false;
    public syncId: number;
    public acctkey: string;
    public upgradProductName: string;
    private tokenData: ValidateTokenOutput;
    public passwordForm: FormGroup;
    public show2FA: boolean;

    constructor(
        private log: LoggerService,
        private maService: MultiAdminService,
        private fb: FormBuilder,
        private provisionService: ProvisionService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.passwordForm = this.fb.group({
            email: [{ value: '', disabled: true }, Validators.required],
            password: ['', Validators.required],
            twofacode: ['']
        });
        this.confirmcode = this.route.snapshot.queryParams['c'];
        if (this.confirmcode) {
            this.verifyEmailInvite();
        } else {
            this.errcode = new ErrCode(8103, 'No confirmation code provided');
        }
    }

    public async verifyEmailInvite() {
        try {
            this.tokenData = await this.maService.verifyLegacyUserEmailInvite(this.confirmcode);
            if (!this.tokenData.migrated) {
                this.isInviteValid = this.tokenData.success ? true : false;
                this.isPaid = this.tokenData.isPro;
                this.syncId = this.tokenData.user_id;
                this.acctkey = this.tokenData.acctkey;
                this.upgradProductName = this.tokenData.upgradProductName;
                this.passwordForm.get('email').setValue(this.tokenData.email);
            }
        } catch (ex) {
            this.log.error(ex);
            this.errcode = ErrCode.fromException(ex);
        }
        this.isInviteChecked = true;
        this.spinner = false;
    }

    public async userReaction(accepted: boolean) {
        this.errcode = null;
        this.spinner = true;
        if (accepted) {
            const email = this.passwordForm.get('email').value;
            const pwd = this.passwordForm.get('password').value;
            const twofacode = this.passwordForm.get('twofacode').value;
            const userId = this.syncId;
            const acctkey = this.acctkey;
            try {
                const sData = await this.maService.getPwdKeysData(email, pwd, twofacode);
                const provisionData = await this.provisionService.mkData(email, pwd, 1, 0);
                provisionData.signup.is_trial = false;
                provisionData.businessTeams = true;
                provisionData.paidToCNC = true;
                provisionData.source = 'neworder';
                provisionData.saltData = JSON.stringify(sData);
                provisionData.existingUserForCncId = userId;
                provisionData.isLegacyToCNC = true;
                provisionData.upgradProductName = this.upgradProductName;
                const result = await this.provisionService.handleAcceptedInviteConsent<{ success: boolean; user_id: number; sessionId?: string; }>(provisionData);
                if (result.success) {
                    await this.provisionService.createNewOrderForMigration(acctkey);
                    this.acceptSuccess = true;
                } else {
                    this.isInviteValid = false;
                }
            } catch (ex) {
                if (ex.code === 8022) {
                    this.show2FA = true;
                } else {
                    this.log.error(ex);
                    this.errcode = ErrCode.fromException(ex);
                }
            }
            this.spinner = false;
        } else {
            try {
                const result = await this.provisionService.addDeclinedNoteInSPIN(this.tokenData.user_id);
                if (result) {
                    this.declineSuccess = true;
                } else {
                    this.isInviteValid = false;
                }
            } catch (ex) {
                this.log.error(ex);
                this.errcode = ErrCode.fromException(ex);
            }
            this.spinner = false;
        }
    }

    public async sendEmailToTeamMembers(accepted: boolean) {
        try {
            if (confirm('Are you sure you want to send this email?')) {
                const userId = this.syncId;
                const result = await this.maService.sendEmailToTeamMembers(userId);
                if (result.success) {
                    alert('We have sent an email to all your team members related to updating the Sync APP.');
                    return false;
                }
            }

        } catch (ex) {
            this.log.error(ex);
            this.errcode = ErrCode.fromException(ex);
        }
    }
}
